const { default: Sorter } = require("./sorter");

export default class AlphabeticProductSorter extends Sorter {
    /** @inheritdoc */
    sort(a, b) {
        let aTitle = a.querySelector('h2.product-title').textContent;
        let bTitle = b.querySelector('h2.product-title').textContent;

        return ('' + aTitle).localeCompare(bTitle) * (this.order === 'desc' ? -1 : 1);
    }
}